module.exports = __webpack_public_path__ + "img/img82.7d16e5a0.svg";